import React, { useState, useEffect } from 'react';
import { LIST_STATE_KEYS } from '../../config/listStateKeys';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RayTable, RayTreeview, AdminProductListHeader } from '../../components/common';
import { ProductAction } from '../../actions/ProductAction';
import { CompanyAction } from '../../actions';
import { ProgramConstant } from '../../actions/constants/ProgramConstant';
import { Translate as t } from '../../config/Translate';
import { canTransferProductOperator } from '../../lib/rbacGuard';
import ProductTransferModal from '../../components/product/ProductTransferModal';

const AdminProductStockList = ({ su, user, GetProductAllStock, BulkUpdateTransferInfo, products, totalproductcount,
	filterDateOptions, filterOptions, filters, sort, companies, viewTree }) => {

	const [showModal, setShowModal] = useState(false);
	const [bulkList, setBulkList] = useState([]);
	const [payloads, setPayloads] = useState({});
	const [companyList, setCompanyList] = useState([]);

	const [wHg, setwHg] = useState(300);
	const [wAll, setwAll] = useState(window.innerWidth);
	const [filterCompanyId, setFilterCompanyId] = useState("");
	const [filterCompany, setFilterCompany] = useState({ name: "ALL" });
	const dispatch = useDispatch();

	const filterpage = {
		filters: filters || {},
		filterOptions: ['model'],
		searchCols: ['model', 'option', 'sn', 'company'],
		sort: sort || { updateDate: -1 },
		searchKey: "",
		page: 1,
		itemperpage: user.settings?.dashboardtablelistcount || 30
	};

	const options = {
		isShowCheckBox: true,
		showClear: true,
		search: true,
		keyCol: 'sn',
		defaultSort: filterpage.sort && Object.keys(filterpage.sort)[0],
		defaultSortType: filterpage.sort && Object.values(filterpage.sort)[0],
		linkto: '/Admin/AdminProductInfo',
		getList: GetProductAllStock,
		linkkey: 'sn',
		filterpageoption: filterpage,
		filters: filterpage.filters,
		itemperpage: filterpage.itemperpage,
		useapi: true,
		totalitemcount: totalproductcount,
		filterOptions: filterOptions
	};

	const checkedList = (list) => {
		setBulkList(list);
	}

	const doBulkCallback = async (companyId, reason) => {
		setShowModal(false);
		const result = await BulkUpdateTransferInfo(bulkList, companyId, reason);
		// 재고 목록엔 회사 열이 없어 sn 별 행 교체만으로는 이관 결과가 안 보인다 — 표가 마지막으로 쓴 조건으로 재조회
		if (result?.status === 'success') GetProductAllStock(payloads);
	}

	const bulkActionDo = () => {
		setShowModal(true);
	}

	// BUG-193: Transfer 는 제품 소유 회사(companyId) 일괄 이전이다. BE 는 이를
	//   adminType 'S' + target ∈ 자기 active subtree 로 제한하는데(BUG-192/193
	//   canCallerChangeCompanyIdTo), FE 에 게이트가 없어 권한 없는 계정에도 버튼이 노출됐고
	//   실행하면 companyId 가 drop 되어 아무 일도 일어나지 않았다.
	//   adminType 을 기준으로 삼는다 — su(org===HQ)는 HQ 소속 M/U 도 true 라 게이트로 부적절하며,
	//   BE 도 su 이전에 adminType==='S' 를 하드 게이트한다. subtree 검증은 BE 가 SSoT.
	//   SEC-051: 같은 정책이 필요한 화면이 3곳(이 화면=updatebulk, AdminProductList /
	//   AdminProductCompanyImport=updatetransferbulk)이라 판정을 rbacGuard 공유 primitive 로 승격.
	const canTransferOperator = canTransferProductOperator({ adminType: user?.adminType });
	const bulkActions = canTransferOperator
		? [{ title: t('common.button.transfer'), action: "TRANSFER" }]
		: []

	useEffect(() => {
		let alive = true;
		const loadCompanies = async () => {
			try {
				const list = await CompanyAction.GetCompanyLocal();
				if (!alive) return;
				setCompanyList((Array.isArray(list) ? list : []).map((c) => ({
					code: c?.companyId,
					title: c?.country ? "[" + c.country + "] " + (c?.name ?? "") : (c?.name ?? ""),
				})));
			} catch (error) {
				console.warn('[AdminProductStockList] company list load failed', { handler: 'AdminProductStockList.loadCompanies', reason: error?.message });
			}
		};
		loadCompanies();
		return () => { alive = false; };
	}, []);

	useEffect(() => {
		if (viewTree) {
			setwHg(300);
		} else {
			setwHg(0);
		}
	}, [viewTree]);

	const getWidth = () => setwAll(window.innerWidth);

	useEffect(() => {
		// window.addEventListener('resize', getWidth);
		// setwAll(window.innerWidth);
		dispatch({ type: ProgramConstant.SET_PRODUCTLISTISSTOCK, isstock: true })
	}, []);

	const onChangeTreeviewItem = (item) => {
		setFilterCompanyId({ companyId: item.id });
		setFilterCompany(item);
	}

	const updateViewTree = (bl) => {
		dispatch({ type: ProgramConstant.VIEWTREE, val: bl });
	}

	return (
		<>
			<div className="extraHeader">
				<h2 className="mb-0">{t('product.label.stockList')}
					{companies.length > 1 && <button className="btn btn-secondary btn-sm mt-0 ms-1" onClick={() => updateViewTree(!viewTree)}>
						{filterCompany.name && <>
							{filterCompany.country && "[" + filterCompany.country + "] "}{filterCompany.name}
						</>}
					</button>}
				</h2>
				<div className="ray-right">
					<Link to="/Admin/AdminProductDashboard" className="btn btn-sm mt-0">
						<ion-icon name="desktop-outline"></ion-icon> {t('dashboard.title')}
					</Link>
				</div>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				{(viewTree && user.adminType != "U") &&
					<div className={viewTree ? "section fl p-0" : "section p-0 fl"} style={{ width: wHg }}>
						<div className='p-1'>
							<RayTreeview onClickItem={onChangeTreeviewItem} onResize={setwHg} stateKey={LIST_STATE_KEYS.ADMIN_PRODUCT_STOCK} />
						</div>
					</div>}
				<div className="section m-1 p-0">
					<div className="card p-2">
						<div className={user.adminType != "U" ? "fl" : ""}>
							<RayTable
								stateKey={LIST_STATE_KEYS.ADMIN_PRODUCT_STOCK}
								data={products}
								addFilter={filterCompanyId}
								bulkActions={bulkActions}
								bulkActionDo={bulkActionDo}
								checkBoxCallback={(list) => checkedList(list)}
								payloadCallback={(pl) => setPayloads(pl)}
								columns={AdminProductListHeader}
								options={options}
							/>
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
			<ProductTransferModal show={showModal}
				onClose={() => setShowModal(false)}
				onTransfer={(companyId, reason) => doBulkCallback(companyId, reason)}
				companies={companyList} />
		</>
	);
};

const mapState = (state) => {
	const user = state.AuthReducer.user;
	const su = state.AuthReducer.su;
	const viewTree = state.ProgramReducer.viewtree;
	const companies = state.CompanyReducer.companies;
	const products = state.ProductReducer.products;
	const totalproductcount = state.ProductReducer.totalproductcount;
	const filterOptions = state.ProductReducer.filterOptions;
	const filterDateOptions = state.ProductReducer.filterDateOptions;
	const filters = state.ProductReducer.filters;
	const sort = state.ProductReducer.sort;
	return { user, su, products, totalproductcount, filterOptions, filters, sort, filterDateOptions, viewTree, companies };
};

const mapDispatch = (dispatch) => ({
	GetProductAllStock: (filter) => dispatch(ProductAction.GetProductAllStock(filter)),
	BulkUpdateTransferInfo: (sns, data, reason) => dispatch(ProductAction.BulkUpdateTransferInfo(sns, data, reason)),
});

export default connect(mapState, mapDispatch)(AdminProductStockList);